package com.neurobs.react

import slinky.core.facade.ReactElement
import slinky.web.html._

import scala.scalajs.js

object ReactElementFactory {

  private def TemplateA(text: String, linkHref: String, linkTarget: String, linkDownload: Boolean)(elementModifiers: ElementModifiers) = {
    a(
      href := linkHref,
      download := linkDownload,
      target := linkTarget,
      className := elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      text
    )
  }

  def A(text: String, href: String, target: String, download: Boolean = false)(implicit elementModifiers: ElementModifiers) = {
    TemplateA(text, href, target, download)(elementModifiers)
  }

  private def TemplateP(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    p(
      className := elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children
    )
  }

  def P(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateP(children)(elementModifiers)
  }

  def OnClickText(handleClick: () => Unit)(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    val newModifiers = elementModifiers.withExtraAttrs(("cursor", "pointer"), ("color", "#0000A0"))
    p(
      className := newModifiers.classString,
      style := newModifiers.createStyle,
      onClick := handleClick
    )(
      children
    )
  }

  def Br(implicit elementModifiers: ElementModifiers): ReactElement = {
    br(
      className := elementModifiers.classString,
      style := elementModifiers.createStyle
    )
  }

  private def TemplateDiv(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    div(
      className := elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children:_*
    )
  }

  def Div(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateDiv(children)(elementModifiers)
  }

  private def TemplateSpan(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    span(
      className := elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children:_*
    )
  }

  def Span(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateSpan(children)(elementModifiers)
  }

  private def TemplateTableHead(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    thead(
      className := elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children
    )
  }

  def TableHead(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateTableHead(children)(elementModifiers)
  }

  private def TemplateTableBody(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    tbody(
      className := elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children
    )
  }

  def TableBody(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateTableBody(children)(elementModifiers)
  }

  private def TemplateTableRow(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    tr(
      className := elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children
    )
  }

  private def TemplateTableRow(handleClick: () => Unit)(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    tr(
      className := elementModifiers.classString,
      style := elementModifiers.createStyle,
      onClick := handleClick
    )(
      children
    )
  }

  def TableRow(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateTableRow(children)(elementModifiers)
  }

  def SelectableTableRow(handleClick: () => Unit)(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateTableRow(handleClick)(children)(elementModifiers)
  }

  private def TemplateTh(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    th(
      className := elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children
    )
  }

  def Th(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateTh(children)(elementModifiers)
  }

  private def TemplateTd(children: ReactElement*)(elementModifiers: ElementModifiers) = {
    td(
      className := elementModifiers.classString,
      style := elementModifiers.createStyle
    )(
      children
    )
  }

  def Td(children: ReactElement*)(implicit elementModifiers: ElementModifiers) = {
    TemplateTd(children)(elementModifiers)
  }

}
